<template>
  <div ref="chatContainer" class="ai-chat-messages">
    <AIWelcomeMessage 
      :hideQuickOptions="hasMessages"
      @quick-option-selected="handleQuickOption"
    />
    
    <template v-for="(msg, index) in messages" :key="index">
      <AIMessageUnit 
        :message="msg"
        :type="msg.type"
      />
    </template>
    
    <AILoadingMessage v-if="isLoading" />
  </div>
</template>

<script>
import AIWelcomeMessage from './AIWelcomeMessage.vue';
import AIMessageUnit from './AIMessageUnit.vue';
import AILoadingMessage from './AILoadingMessage.vue';

export default {
  name: 'AIChatMessages',
  components: {
    AIWelcomeMessage,
    AIMessageUnit,
    AILoadingMessage
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasMessages() {
      return this.messages.length > 0;
    }
  },
  emits: ['quick-option-selected'],
  watch: {
    messages: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true
    },
    isLoading() {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
  },
  methods: {
    handleQuickOption(option) {
      this.$emit('quick-option-selected', option);
    },
    scrollToBottom() {
      const container = this.$refs.chatContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }
  }
};
</script>

<style scoped>
.ai-chat-messages {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 0;
}

.ai-chat-messages::-webkit-scrollbar {
  width: 6px;
}

.ai-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.ai-chat-messages::-webkit-scrollbar-thumb {
  background: #C4C4C4;
  border-radius: 3px;
}

.ai-chat-messages::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>
